import type { CSSProperties, ReactNode } from 'react';
import { useFadeUp } from '../../hooks/useFadeUp';
import { EASE } from '../../tokens';

interface FadeUpProps {
  children: ReactNode;
  /** Stagger in milliseconds, applied as a transition delay. */
  delay?: number;
  style?: CSSProperties;
}

/** Wrapper that fades and lifts its children in the first time they scroll into view. */
export function FadeUp({ children, delay = 0, style = {} }: FadeUpProps) {
  const [ref, visible] = useFadeUp<HTMLDivElement>();

  return (
    <div
      ref={ref}
      style={{
        opacity: visible ? 1 : 0,
        transform: visible ? 'translateY(0)' : 'translateY(32px)',
        transition: `opacity 0.75s ${EASE} ${delay}ms, transform 0.75s ${EASE} ${delay}ms`,
        ...style,
      }}
    >
      {children}
    </div>
  );
}
